import { createAction } from '../../utils/redux/createAction';

const actionScope = 'virtual-visit';

export const VIRTUAL_VISIT_TYPES = {
  SET_FULL_SCREEN_VIEW: `${actionScope}/set-full-screen-view`,
  TOGGLE_MOB_SIDEBAR: `${actionScope}/toggle-mob-sidebar`,
  SET_VISIBILITY: `${actionScope}/set-visibility`,
  SET_COLLAPSING: `${actionScope}/set-collapsing`,
  SET_DRAGGING: `${actionScope}/set-draging`,
  SET_CONFIG: `${actionScope}/set-config`,
  SET_ACTIVE: `${actionScope}/set-active`,
  RESET: `${actionScope}/reset`,
};

export const virtualVisitActions = {
  setFullScreenView: createAction(VIRTUAL_VISIT_TYPES.SET_FULL_SCREEN_VIEW),
  toggleMobSidebar: createAction(VIRTUAL_VISIT_TYPES.TOGGLE_MOB_SIDEBAR),
  setVisibility: createAction(VIRTUAL_VISIT_TYPES.SET_VISIBILITY),
  setCollapsing: createAction(VIRTUAL_VISIT_TYPES.SET_COLLAPSING),
  setDragging: createAction(VIRTUAL_VISIT_TYPES.SET_DRAGGING),
  setConfig: createAction(VIRTUAL_VISIT_TYPES.SET_CONFIG),
  setActive: createAction(VIRTUAL_VISIT_TYPES.SET_ACTIVE),
  reset: createAction(VIRTUAL_VISIT_TYPES.RESET),
};

const initialState = {
  isOpenedMobSidebar: false,
  fullScreenView: false,
  opened: false,
  collapsed: false,
  dragging: false,
  active: false,
  config: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case VIRTUAL_VISIT_TYPES.SET_VISIBILITY: {
      return { ...state, opened: payload };
    }

    case VIRTUAL_VISIT_TYPES.SET_COLLAPSING: {
      return { ...state, collapsed: payload };
    }

    case VIRTUAL_VISIT_TYPES.SET_DRAGGING: {
      return { ...state, dragging: payload };
    }

    case VIRTUAL_VISIT_TYPES.SET_CONFIG: {
      return { ...state, config: payload };
    }

    case VIRTUAL_VISIT_TYPES.SET_ACTIVE: {
      return { ...state, active: payload };
    }

    case VIRTUAL_VISIT_TYPES.RESET: {
      return { ...initialState };
    }

    case VIRTUAL_VISIT_TYPES.TOGGLE_MOB_SIDEBAR: {
      return { ...state, isOpenedMobSidebar: !state.isOpenedMobSidebar };
    }

    case VIRTUAL_VISIT_TYPES.SET_FULL_SCREEN_VIEW: {
      return { ...state, fullScreenView: payload };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/healthboard/virtual-visit.js